import React, { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Bell, DotsThree , X, User, Settings, SignOut  } from "phosphor-react"
import { useAuth } from "../../utils/context/AuthContext"
import { motion, AnimatePresence } from "framer-motion"
import useCurrentUser from '../../utils/hooks/useCurrentUser';

export default function Navbar({ isOpen, setIsOpen, isMobile }) {
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false)
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false)
  const { currentUser, fetchUser } = useCurrentUser();

  const notifications = [
    { id: 1, message: "New message received", time: "5 minutes ago" },
    { id: 2, message: "Your order has been shipped", time: "2 hours ago" },
    { id: 3, message: "Payment successful", time: "1 day ago" },
  ]

  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleSignOut  = (e) => {
    e.preventDefault()
    logout()
    navigate("/login")
  }



  useEffect(() => {
    fetchUser()
  }, [])


  const dropdownVariants = {
    hidden: {
      opacity: 0,
      y: -10,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
  }

  return (
    <nav className="bg-white  sticky
     border-b">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-[4.5rem]">
          {/* Left side - Logo */}
          <div className="flex items-center">
            {isMobile && !isOpen && (
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="   z-50  bg-cyan-400 p-2  rounded-full text-white  focus:outline-none"
              >
                <DotsThree  className="h-5 w-5" />
              </button>
            )}
          </div>

          {/* Right side - Notifications and User Dropdown */}
          <div className="flex items-center gap-2">
            {/* Notifications */}
            <div className="relative">
              {/* <button
                className="relative p-2 border border-neutral-200 rounded-full text-neutral-600 hover:text-neutral-900 focus:outline-none"
                onClick={() => setIsNotificationDropdownOpen(!isNotificationDropdownOpen)}
                aria-label="Notifications"
              >
                <Bell className="h-5 w-5" />
                <motion.span
                  className="absolute top-1.5 right-1.5 flex h-2 w-2"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 20,
                  }}
                >
                  <motion.span
                    className="absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"
                    animate={{ scale: [1, 1.5, 1] }}
                    transition={{
                      duration: 2,
                      repeat: Number.POSITIVE_INFINITY,
                      ease: "easeInOut",
                    }}
                  ></motion.span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-blue-500"></span>
                </motion.span>
              </button> */}

              {/* Notification Dropdown */}
              {/* <AnimatePresence>
                {isNotificationDropdownOpen && (
                  <motion.div
                    className="absolute right-0 mt-2 w-80 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5"
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={dropdownVariants}
                  >
                    <div className="px-4 py-2 flex justify-between items-center border-b border-neutral-200">
                      <h3 className="text-sm font-semibold text-neutral-900">Notifications</h3>
                      <button
                        onClick={() => setIsNotificationDropdownOpen(false)}
                        className="text-neutral-400 hover:text-neutral-500"
                        aria-label="Close notifications"
                      >
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                    <div className="max-h-64 overflow-y-auto">
                      {notifications.map((notification) => (
                        <div key={notification.id} className="px-4 py-3 hover:bg-neutral-50">
                          <p className="text-sm text-start text-neutral-700">{notification.message}</p>
                          <p className="text-xs text-start text-neutral-500 mt-1">{notification.time}</p>
                        </div>
                      ))}
                    </div>
                    <div className="px-4 py-2 border-t border-neutral-200">
                      <Link
                        to="/notifications"
                        className="block text-sm text-center text-blue-600 hover:text-blue-700"
                        onClick={() => setIsNotificationDropdownOpen(false)}
                      >
                        View all notifications
                      </Link>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence> */}
            </div>

            {/* User Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                className="relative  border rounded-xl border-neutral-200 p-2 text-neutral-600 hover:text-neutral-900 focus:outline-none"
                aria-label="User menu"
                aria-expanded={isUserDropdownOpen}
              >
                <User className="h-5 w-5" />
              </button>

              {/* User Dropdown DotsThree  */}
              <AnimatePresence>
                {isUserDropdownOpen && (
                  <motion.div
                    className="absolute right-0 mt-2 w-48 z-50 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5"
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={dropdownVariants}
                  >
                    <div className="px-4 py-3 border-b border-neutral-100">
                      <div className="flex justify-center items-center">
                      
                        <div>
                          <div className="font-medium text-sm text-neutral-900">{currentUser?.fullName}</div>
                          <div className="text-xs text-start text-neutral-500">{currentUser?.role?.name}</div>
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/settings"
                      className="flex items-center px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
                      onClick={() => setIsUserDropdownOpen(false)}
                    >
                      <User className="mr-2 h-4 w-4" />
                      Your Profile
                    </Link>

                    <div className="border-t border-neutral-100">
                      <button
                        onClick={(e) => {
                          handleSignOut (e)
                        }}
                        className="flex w-full items-center px-4 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-100"
                      >
                        <SignOut  className="mr-2 h-4 w-4" />
                        Sign out
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

